import { useEffect, useState } from 'react'
import {
  buildStockListLabel,
  getStockListNames,
} from 'src/store/lists/stockListInfo'

/**
 * Resolves the tooltip copy for parts that live on a stock list.
 *
 * Prefers `stockedLists` from verifyStockedAndTaggedParts when provided.
 * Falls back to GET /list stock list names when the verify payload omits them.
 *
 * @param enabled When false the lookup is skipped.
 * @param stockedLists Stock list names returned for this part by the verify API.
 * @returns The tooltip message, or undefined until it has been resolved.
 */
export const useStockListLabel = (
  enabled: boolean,
  stockedLists?: string[]
): string | undefined => {
  const [label, setLabel] = useState<string | undefined>(undefined)
  const stockedListsKey = stockedLists?.join('\0')

  useEffect(() => {
    let cancelled = false

    const resolveLabel = async (): Promise<void> => {
      if (!enabled) {
        setLabel(undefined)
        return
      }

      if (stockedListsKey !== undefined) {
        const names =
          stockedListsKey.length > 0 ? stockedListsKey.split('\0') : []
        setLabel(buildStockListLabel(names))
        return
      }

      const names = await getStockListNames()
      if (!cancelled) setLabel(buildStockListLabel(names))
    }

    resolveLabel()

    return () => {
      cancelled = true
    }
  }, [enabled, stockedListsKey])

  return label
}
